import account from './module/account/account';
import hybridCoaching from './module/hybrid-coaching/hybrid-coaching';
import ing from './module/ing';

// API list
let apiStructure = {
  ...account,
  ...hybridCoaching,
};

if (process.env.VUE_APP_PLATFORM === 'ING') {
  apiStructure = {
    ...apiStructure,
    ...ing,
  };
}

const api = { ...apiStructure };

export default api;
